import { Home } from "./Pages";

import Hero from "./assets/blueSky3.png";

function App() {
  return (
    <div className="h-full">
      <div
        style={{ backgroundImage: `url(${Hero})` }}
        className="bg-no-repeat bg-cover h-screen"
      >
        <Home />
      </div>
    </div>
  );
}

export default App;